<li class="hidden">
  <img src="{{status_image}}" width="12" height="12" alt="{{status_msg}}" title="{{status_msg}}" class="status"/>
  {{name}} ({{email}})
  <a href="{{path}}" class="delete" data-method="delete" data-remote="true" rel="nofollow">entfernen</a>
</li>
